<script setup>
import { ref, computed, onMounted } from 'vue';
import { useWidgets } from '@store/widgets';
import { useRoute } from 'vue-router'
import { Button, NewBadge, Spin } from '@components'
import { useTranslation } from '../../composables/useTranslation';

const { t } = useTranslation();
const $widget = useWidgets();
const route = useRoute();

const barWidth = computed( () => {
    const currentTabIndex = $widget.tabs.findIndex( tab => tab.path == route.query.tab )
    return (currentTabIndex / ($widget.tabs.length - 1)) * 100
})
onMounted(() => {
    // WhatsApp is the default tab.
    if ( $widget.isTabEmpty ) {
        $widget.setTab( 'whatsapp' )
    }
})

const prevButtonText = computed( () => {
    return $widget.isTab('whatsapp') ? t('cancel') : t('prev_arrow')
})

const nextButtonText = computed( () => {

    if ( $widget.isTab('triggers') ) {

        if ( $widget.currentWidget.isNew ) {
            return $widget.currentWidget.is_saving ? t('creating') : t('create')
        } 

        return $widget.currentWidget.is_saving ? t('saving') : t('save_check')
    }

    return t('next_arrow');
})

</script>

<template>
    <div class="w-full relative">
        <!-- bar  -->
         <div class="absolute top-[13px] left-[12%] right-1/2 transition h-1 w-[calc(75%)] duration-100 bg-slate-200">
            <div class="absolute h-full bg-indigo-600 left-0 top-0 transition-[width] duration-200" :style="{ width: barWidth + '%'}"></div>
         </div>

         <!-- tabs  -->
        <div class="grid grid-cols-4 w-full h-16 z-0">
            <div v-for="tab in $widget.tabs" class="flex items-center flex-col justify-start cursor-pointer transition duration-100 relative font-medium">
                <!-- round circle  -->
                <div class="w-4 h-4 rounded-full z-0 translate-y-1.5 delay-75" @click.prevent="$widget.setTab( tab.path )" :class="[$widget.isTabDone( tab.path ) ? 'bg-indigo-600' : 'bg-slate-300']"></div>
                
                <!-- title  -->
                <div class="py-2 flex items-center" @click.prevent="$widget.setTab( tab.path )" :class="$widget.isTabDone( tab.path ) ? 'text-indigo-600' : 'text-slate-300'">
                    <span class="hidden sm:flex">{{ tab.id }} .</span>
                    <span class="sm:flex sm:ml-1 text-center">{{ t('tab_' + tab.path) }}</span>
                </div>
            </div>
        </div>

        <!-- save buttons  -->
         <div class="flex  items-center justify-between gap-3 my-4 w-full flex-col sm:flex-row">
            <div class="text-lg font-medium">{{ t('step') }} {{ $widget.currentTab.id }} : {{ t('tab_' + $widget.currentTab.path) }}</div>
            <div class="flex z-10 items-center w-full sm:w-fit gap-6 sm:justify-end sm:gap-2" :class="{'justify-end' : $widget.isTab('whatsapp'), 'justify-between' : !$widget.isTab('whatsapp')}">
                <Button v-if="!$widget.isTab('whatsapp')" outline @click="$widget.prevTab()">{{ prevButtonText }}</Button>
                <Button @click="$widget.isTab('triggers') ? $widget.saveWidget() : $widget.nextTab()" :class="{ 'opacity-60 pointer-events-none' : $widget.currentWidget.is_saving }">
                    <Spin class="w-3.5 h-3.5" v-if="$widget.currentWidget.is_saving" /> 
                    
                      {{ nextButtonText }}</Button>
            </div>
         </div>
    </div>
</template>